<div [class.active]="active" class="bar">
  <div class="filled" [style.width]="filledPercent"></div>
</div>